module.exports = __webpack_public_path__ + "static/media/SourceHanSansCN-Medium.c49a42ee.svg";